var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6964_3470",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6964_3470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.6L7.10005 5.69995C6.91672 5.51662 6.68338 5.42495 6.40005 5.42495C6.11672 5.42495 5.88338 5.51662 5.70005 5.69995C5.51672 5.88329 5.42505 6.11662 5.42505 6.39995C5.42505 6.68328 5.51672 6.91662 5.70005 7.09995L10.6 12L5.70005 16.9C5.51672 17.0833 5.42505 17.3166 5.42505 17.6C5.42505 17.8833 5.51672 18.1166 5.70005 18.3C5.88338 18.4833 6.11672 18.575 6.40005 18.575C6.68338 18.575 6.91672 18.4833 7.10005 18.3L12 13.4L16.9 18.3C17.0834 18.4833 17.3167 18.575 17.6 18.575C17.8834 18.575 18.1167 18.4833 18.3 18.3C18.4834 18.1166 18.575 17.8833 18.575 17.6C18.575 17.3166 18.4834 17.0833 18.3 16.9L13.4 12L18.3 7.09995C18.4834 6.91662 18.575 6.68328 18.575 6.39995C18.575 6.11662 18.4834 5.88329 18.3 5.69995C18.1167 5.51662 17.8834 5.42495 17.6 5.42495C17.3167 5.42495 17.0834 5.51662 16.9 5.69995L12 10.6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.f964ca1d4c645ae6cdd9d12538082f79.svg";
export { ForwardRef as ReactComponent };